import React from "react";

import { MenuItem } from "../../utils/menuItem";
import { CDrawnerMobile, CDrawer } from "../navigation";
import { useScreenSize } from "../../hooks";

interface Props {
  children?: React.ReactNode;
}

const LayoutDashboard = ({ children }: Props) => {
  const { width } = useScreenSize();
  return (
    <div>
      {width < 900 ? (
        <CDrawnerMobile data={MenuItem}>{children}</CDrawnerMobile>
      ) : (
        <CDrawer data={MenuItem}>{children}</CDrawer>
      )}
    </div>
  );
};

export default LayoutDashboard;
